<template>
  <div class="similares">
    <template v-if="loading">
      <div class="loading-similares">
        <img src="@/assets/imgs/puff.svg" alt="Loading..." />
      </div>
    </template>
    <template v-if="!loading && similares.data.length > 0">
      <h2>APARELHOS SIMILARES</h2>
      <div class="relacionados">
        <div class="botao-nav" v-if="similares.paginate.to > 4">
          <a @click="anterior()">&lsaquo;</a>
        </div>
        <div class="cx-celulares">
          <router-link
            v-for="(item) in pagina"
            :to="{
            name: 'vivo.consulta.page',
            params: { page: 'smartphone', id: item.cel.id },
          }"
            class="com-filtro"
            :key="item.id"
          >
            <transition name="fade">
              <div class="celular">
                <aparelho-similar-imagem :imagem="item.cel.imagem" />
                <div class="informacoes">
                  <h3>
                    {{ item.cel.marca.nome }}
                    <br />
                    <strong>{{ item.cel.modelo }}</strong>
                  </h3>
                  <p>
                    R$
                    <strong>{{ item.cel.preco | convertMoeda }}</strong>
                  </p>
                </div>
              </div>
            </transition>
          </router-link>
        </div>
        <div class="botao-nav" v-if="similares.paginate.to > 4">
          <a @click="proxima()">&rsaquo;</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AparelhoSimilarImagem from './AparelhoSimilarImagem';
export default {
  name: 'AparelhoSimilar',
  components: {
    AparelhoSimilarImagem,
  },
  props: {
    similares: {
      type: [Array, Object],
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    numPages: 0,
    pageCurrent: 0,
    numCelularesMin: 0,
    numCelularesMax: 4,
    pagina: [],
    indexInicial: 0,
    windowWidth: window.innerWidth,

  }),
  methods: {
    proxima() {      
      this.indexInicial = this.indexInicial + this.passo;
      if(this.indexInicial >= this.similares.data.length) this.indexInicial = 0
      this.pagina = this.similares.data.slice(this.indexInicial, this.indexInicial + this.passo)
    },
    anterior() {
      this.indexInicial = this.indexInicial - this.passo
      if(this.indexInicial < 0) this.indexInicial = this.similares.data.length - this.passo
      this.pagina = this.similares.data.slice(this.indexInicial, this.indexInicial + this.passo)
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.pagina = this.similares.data.slice(0, this.passo)
    }
  },
  computed:{
    passo(){
      if(this.windowWidth > 500) return 4;
      if(this.windowWidth > 350) return 3;
      return 2;
    }
  },
  mounted() {
    this.pagina = this.similares.data.slice(0, this.passo)
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })
    this.windowWidth = window.innerWidth
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
};
</script>

<style lang="scss" scoped>
.loading-similares {
  width: 100%;
  min-height: 320px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';
.similares {
  margin: 70px 0;

  & h2 {
    font-size: 22px;
    font-family: 'VivoType';
    font-weight: bold;
    color: $cor_roxo;
    text-align: center;
  }
  .botao-nav {
    display: flex;
    font-size: 40px;
    height: 100%;
    padding-bottom: 40px;
    & a{
      flex-direction: column;
    }
  }

  & .relacionados {
    display: flex;
    flex: 0.33;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    align-self: flex-start;
    margin: 0 auto;
    margin-top: 50px;
    max-width: 980px;
    height: 310px;
    padding: 0;

    .celular {
      width: 80%;
    }

    & a {
      user-select: none;
      text-decoration: none;
      display: flex;      
      align-items: stretch;
      justify-content: center;
      margin: 0px;
      margin-bottom: 50px;
      // height: 300px;
      transition: all 0.2s ease-in-out;
      color: $cor_cinza_darkest;

      /* & .foto {
        display: flex;
        align-items: center;
        justify-content: center;

        & img {
          height: 180px;
          max-height: 180px;
          object-fit: contain;
          width: auto;
        }
      } */

      & .informacoes {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        & h3 {
          font-family: 'OpenSans';
          text-align: center;
          color: $cor_cinza_dark;
          font-weight: 300;
          font-size: 16px;
          margin: 10px 0 0;
          max-width: 90%;
          line-height: 1em;
          text-transform: uppercase;
          @media (max-width: 650px) {
            font-size: 13px;
          }

          & strong {
            font-family: 'VivoType';
          }
        }

        & p {
          color: $cor_cinza_dark;
          font-size: 17px;
          margin: 0px;
          font-weight: 100;
          @media (max-width: 650px) {
            font-size: 15px;
          }

          & strong {
            font-weight: 700;
          }
        }
      }

      &:hover {
        transform: scale(1.04);
        // perspective: 100px;
        // transform: rotateY(360deg);
        // transform-style: preserve-3d
      }

      // &::after {
      //   content: "";
      //   flex: 0 0 380px;
      // }
    }

    & .com-filtro {
      //width: 25%;
    }

    & .sem-filtro {
      width: 20%;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versÃµes anteriores a 2.1.8 */ {
  opacity: 0;
}

.cx-celulares {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
}
</style>
